import React from 'react'

export default class ChartBuilderChartGuidelines extends React.Component {
  constructor(props){
    super(props);
  };

  render() {
    if (this.props.report_details && this.props.report_details.chart_type){
      return(
        <div className="card col">
          {this.renderGuidelines()}
        </div>
      );
    } else {
      return null;
    };
  };

  renderGuidelines() {
    switch(true) {
      case this.props.report_details.chart_type.name === 'line_chart' && this.props.step === 'general': return this.renderLineChartGuidelines();
      case this.props.report_details.chart_type.name === 'area_chart' && this.props.step === 'general': return this.renderAreaChartGuidelines();
      case this.props.report_details.chart_type.name === 'vertical_bar_chart' && this.props.step === 'general': return this.renderVerticalBarChartGuidelines();
      case this.props.report_details.chart_type.name === 'dual_axis_line_chart' && this.props.step === 'general': return this.renderDualAxisLineChartGuidelines();
      case this.props.report_details.chart_type.name === 'horizontal_bar_chart' && this.props.step === 'general': return this.renderHorizontalBarChartGuidelines();
      case (this.props.report_details.chart_type.name === 'line_chart' || this.props.report_details.chart_type.name === 'area_chart' || this.props.report_details.chart_type.name === 'dual_axis_line_chart') && this.props.step === 'primary_axis_details': return this.renderLineAreaDualPrimaryAxisGuidelines();
      case (this.props.report_details.chart_type.name === 'line_chart' || this.props.report_details.chart_type.name === 'area_chart' || this.props.report_details.chart_type.name === 'dual_axis_line_chart') && this.props.step === 'secondary_axis_details': return this.renderLineAreaDualSecondaryAxisGuidelines();
      case this.props.report_details.chart_type.name === 'vertical_bar_chart' && this.props.step === 'primary_axis_details': return this.renderVerticalBarPrimaryAxisGuidelines();
      case this.props.report_details.chart_type.name === 'vertical_bar_chart' && this.props.step === 'secondary_axis_details': return this.renderVerticalBarSecondaryAxisGuidelines();
    };
  };

  renderLineChartGuidelines() {
    return (
      <div className="form-group" style={{marginLeft: '-5px'}}>
        <label>{I18n.t('line_chart_guidelines')}</label>
        <br />
        <ul className="guidlines-list">
          <li>{I18n.t('line_chart_general_explanation')}</li>
          <li>{I18n.t('line_chart_x_axis_restrictions')}</li>
          <li>{I18n.t('line_chart_y_axis_restrictions')}</li>
        </ul>
        <hr/>
        <div>
        <div className="line-chart-sample" style={{ display:'block'}}></div>
        </div>
      </div>
    );
  };

  renderLineAreaDualPrimaryAxisGuidelines() {
    return (
      <div className="form-group" style={{marginLeft: '-5px'}}>
        <label>{I18n.t('x_axis_guidelines')}</label>
        <br />
        <ul className="guidlines-list">
          <li>{I18n.t('line_chart_x_axis_restrictions')}</li>
        </ul>
        {this.props.report_details.chart_type.name === 'line_chart' ? <hr /> : null}
        {this.props.report_details.chart_type.name === 'line_chart' ? <div className="line-chart-primary-axis" style={{ display: 'block' }}></div> : null}
      </div>
    );
  };

  renderLineAreaDualSecondaryAxisGuidelines() {
    return (
      <div className="form-group" style={{marginLeft: '-5px'}}>
        <label>{I18n.t('y_axis_guidelines')}</label>
        <br />
        <ul className="guidlines-list">
          <li>{I18n.t('line_chart_y_axis_restrictions')}</li>
        </ul>
        {this.props.report_details.chart_type.name === 'line_chart' ? <hr /> : null}
        {this.props.report_details.chart_type.name === 'line_chart' ? <div className="line-chart-secondary-axis" style={{ display: 'block' }}></div> : null}
      </div>
    );
  };

  renderAreaChartGuidelines() {
    return (
      <div className="form-group" style={{marginLeft: '-5px'}}>
        <label>{I18n.t('area_chart_guidelines')}</label>
        <br />
        <ul className="guidlines-list">
          <li>{I18n.t('area_chart_general_explanation')}</li>
          <li>{I18n.t('line_chart_x_axis_restrictions')}</li>
          <li>{I18n.t('line_chart_y_axis_restrictions')}</li>
        </ul>
      </div>
    );
  };

  renderVerticalBarChartGuidelines(){
    return (
      <div className="form-group" style={{ marginLeft: '-5px' }}>
        <label>{I18n.t('bar_chart_guidelines')}</label>
        <br />
        <ul className="guidlines-list">
          <li>{I18n.t('vertical_bar_chart_explanation')}</li>
          <li>{I18n.t('vertical_bar_chart_x_axis_restrictions')}</li>
          <li>{I18n.t('vertical_bar_chart_y_axis_restrictions')}</li>
        </ul>
      </div>
    );
  };

  renderVerticalBarPrimaryAxisGuidelines(){
    return (
      <div className="form-group" style={{ marginLeft: '-5px' }}>
        <label>{I18n.t('x_axis_guidelines')}</label>
        <br />
        <ul className="guidlines-list">
          <li>{I18n.t('vertical_bar_chart_x_axis_restrictions')}</li>
        </ul>
      </div>
    );
  };

  renderVerticalBarSecondaryAxisGuidelines(){
    return (
      <div className="form-group" style={{ marginLeft: '-5px' }}>
        <label>{I18n.t('x_axis_guidelines')}</label>
        <br />
        <ul className="guidlines-list">
          <li>{I18n.t('vertical_bar_chart_y_axis_restrictions')}</li>
        </ul>
      </div>
    );
  };

  renderHorizontalBarChartGuidelines(){
    return (
      <div className="form-group" style={{ marginLeft: '-5px' }}>
        <label>{I18n.t('bar_chart_guidelines')}</label>
        <br />
        <ul className="guidlines-list">
          <li>{I18n.t('vertical_bar_chart_explanation')}</li>
          <li>{I18n.t('horizontal_bar_chart_y_axis_restrictions')}</li>
          <li>{I18n.t('horizontal_chart_x_axis_restrictions')}</li>
        </ul>
      </div>
    );
  };

  renderDualAxisLineChartGuidelines(){
    return (
      <div className="form-group" style={{ marginLeft: '-5px' }}>
        <label>{I18n.t('dual_axis_line_chart_guidelines')}</label>
        <br />
        <ul className="guidlines-list">
          <li>{I18n.t('dual_axis_line_chart_general_explanation')}</li>
          <li>{I18n.t('line_chart_x_axis_restrictions')}</li>
          <li>{I18n.t('dual_axis_line_chart_y_axis_restrictions')}</li>
        </ul>
      </div>
    );
  };

};